import clsx from "clsx";

export interface TabsNavItem {
  id: string;
  label: string;
}

interface TabsNavGroup {
  label: string;
  items: TabsNavItem[];
}

interface TabsNavProps<T extends string> {
  groups: TabsNavGroup[];
  active: T;
  onChange: (id: T) => void;
  ariaLabel?: string;
}

const flattenGroup = <T extends string>(
  group: TabsNavGroup,
  active: T,
  onChange: (id: T) => void,
) => (
  <div key={group.label} className="space-y-1">
    <p className="px-2 text-xs font-semibold uppercase tracking-wide text-ink-secondary">
      {group.label}
    </p>
    {group.items.map((item) => (
      <button
        key={item.id}
        type="button"
        onClick={() => onChange(item.id as T)}
        aria-current={item.id === active ? "true" : undefined}
        className={clsx(
          "w-full rounded-md px-3 py-1.5 text-left text-sm transition-colors",
          item.id === active
            ? "bg-accent-blue/15 text-accent-blue"
            : "text-ink-secondary hover:bg-slate-100",
        )}
      >
        {item.label}
      </button>
    ))}
  </div>
);

export const TabsNav = <T extends string>({
  groups,
  active,
  onChange,
  ariaLabel = "Secciones",
}: TabsNavProps<T>) => (
  <nav aria-label={ariaLabel} className="flex flex-col gap-3">
    {groups.map((group) => flattenGroup(group, active, onChange))}
  </nav>
);